import {createContext, useContext} from 'react';

interface Designer {
    name: string;
    role: string;
    image: string;
}

interface ModalContextType {
    openDesignerModal: (designer: Designer) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};

export default ModalContext;
